import { call, put, all, takeLatest } from "redux-saga/effects";

import { confirmTimeKeepingApi } from "core/http/service/timeKeeping";
import {
  confirmTimeKeepingMonthStart,
  confirmTimeKeepingMonthSuccess,
} from "../redux/confirmTimeKeepingMonth";
import { toast } from "react-toastify";
import { getTimeCheckingMonthStart } from "../redux/getTimekeepingMonth";

function* confirmTimeKeepingMonthWork(action) {
  try {
    const res = yield call(confirmTimeKeepingApi, action.payload);
    if (res) {
      yield put({
        type: confirmTimeKeepingMonthSuccess.type,
      });

      yield put({
        type: getTimeCheckingMonthStart.type,
        payload: {
          month: action.payload.month,
          year: action.payload.year,
          screenCode: action.payload.screenCode,
        },
      });
      toast.success(`Xác nhận chấm công của bạn đã được gửi thành công`);
    }
  } catch (err: any) {
    toast.error(err?.response?.data?.message || "Đã có lỗi xảy ra !");
  }
}

function* watchConfirmTimeKeepingMonth() {
  yield takeLatest(
    confirmTimeKeepingMonthStart.type,
    confirmTimeKeepingMonthWork
  );
}

export default function* confirmTimeKeepingMonthSaga() {
  yield all([watchConfirmTimeKeepingMonth()]);
}
